module.exports = __webpack_public_path__ + "img/3.abc968f0.jpg";